import React, { Component } from "react";
import Footer from "../components/base/Footer";
import Header from "../components/base/Header";
import SEO from "../components/base/seo";
import CTAUser from "../components/marketing/CTAUser";
import HeroHome from "../components/marketing/HeroHome";
import Mission from "../components/marketing/Mission";
import Stats from "../components/marketing/Stats";
import Steps from "../components/marketing/Steps";
import VolunteerAct from "../components/marketing/VolunteerAct";
import IlluCall from "../images/illu_call.png";
import IlluDelivery from "../images/illu_delivery.png";
import IlluSupport from "../images/illu_support.png";
import IlluVaccine from "../images/illu_vaccine.png";

const description = [
  "MySukarela started from rolling MyVAC (Malaysia Vaccine Support Volunteers) which is a dedicated platform established in collaboration with the Malaysia Ministries and Malaysian Red Crescent Society (MRCS) to assist in the rollout of the government’s vaccination program, by deploying willing individuals to be part of the vaccination team.",
  "Since rollout on April 2021, MyVac has received tremendous response to aid in the vaccination program in Malaysia. MySukarela was thus established as a one-stop platform to connect volunteers with non-profit organizations (NGOs). The platform will supplement the humanitarian needs of Malaysia by deploying willing and passionate volunteers from all walks of life in this time of crisis.",
  "Everyone is welcome to be part of MySukarela community. Sign up as a volunteer today.",
];

const volunteeringActivities = [
  {
    name: "Call Center Activities",
    description:
      "Volunteer in a call center to communicate and monitor COVID-19 patients via phone call. Knowledge of COVID-19 symptoms and effects are important to understand actions to be taken",
    imageUrl: IlluCall,
  },
  {
    name: "Vaccination/ Disaster Relief Center Activities",
    description:
      "Volunteer in vaccination/ disaster relief center to manage the crowd and ensuring SOP has adhered. Volunteer to provide health counseling and vaccination if you have the necessary credentials",
    imageUrl: IlluVaccine,
  },
  {
    name: "Distributing or Delivering Food",
    description:
      "COVID-19 pandemic or disaster may affect some economic sectors to be closed. Volunteer with NGO in distributing food and necessities to residents affected financially",
    imageUrl: IlluDelivery,
  },
];

export default class HomePage extends Component {
  render() {
    return (
      <div className="display flex flex-col items-center justify-center">
        {/* <Whatsapp /> */}
        <SEO
          title="MySukarela - Home"
          description="MySukarela serves as a platform that connects volunteers with non-profit organizations (NGO) to conduct humanitarian tasks. Find volunteering projects nearby you and get started volunteering now!"
        />
        <Header page="Home" />
        <HeroHome />
        <Mission
          title="On A Mission To Empower Organisations (NGO)"
          description={description}
          image={IlluSupport}
        />
        <VolunteerAct
          title="Types of Volunteering Activities"
          description="Volunteers' credentials and activities required may vary depending on the requirements of NGOs. Currently, MySukarela volunteering projects are focused on combating COVID-19 / disaster / humanitarian-related issues."
          activities={volunteeringActivities}
        />
        <Stats />
        <Steps />
        <CTAUser />
        <Footer />
      </div>
    );
  }
}
